<template>
    <section class="material-list mygallery">
        <div class="mygallery-box">
            <div class="box">
                <v-card
                    class="elevation-0 search-result"
                    v-if="this.keyword.length"
                    tile
                    outlined
                >
                    <v-tabs
                        center-active
                        v-if="navInfos.length"
                        align-with-title
                        v-model="GLOBAL.searchResultModel"
                    >
                        <v-tab @click="on_search_filter(-1)">全部</v-tab>
                        <v-tab
                            v-for="(item, index) in navInfos"
                            :key="index"
                            @click="on_search_filter(index, item.driveId)"
                            >{{ item.name }}</v-tab
                        >
                    </v-tabs>
                </v-card>
                <div class="menu-tag" style="width: 100%" v-else>
                    <lv1TagsList
                        ref="lv1List"
                        v-if="lv1_categories && lv1_categories.length > 0"
                        :tagListBox="lv1_categories"
                        :lv2Categories="lv2_categories"
                        :selectData="select"
                        @get_list_data="get_image_card_list"
                    />
                    <!-- 三级标签 -->
                    <lv2CategoriesTags
                        v-if="lv2_categories.length"
                        :lv1_categories="lv1_categories"
                        :lv2_categories="lv2_categories"
                        @get_list_data="get_image_card_list"
                    />
                </div>

                <div class="filter-box">
                    <p class="search-info" v-show="this.keyword.length">
                        为你找到符合 “<span v-text="this.keyword"></span>”
                        的结果 <span v-text="allCardListMeta.total"></span> 个：
                    </p>
                    <div class="switch-view-mode" v-show="!this.keyword.length">
                        <v-btn-toggle mandatory v-model="toggle_view_mode">
                            <v-btn
                                @click="on_switch_view_mode('', 8, 'unset', 1)"
                            >
                                <div><span class="small-with-meta"></span></div>
                            </v-btn>
                            <v-btn
                                @click="on_switch_view_mode('', 6, 'unset', 1)"
                            >
                                <div>
                                    <span class="large-with-meta"></span>
                                </div>
                            </v-btn>
                            <v-btn
                                @click="
                                    on_switch_view_mode(
                                        'without-meta',
                                        8,
                                        'absolute',
                                        0
                                    )
                                "
                            >
                                <div>
                                    <span class="small-without-meta"></span>
                                </div>
                            </v-btn>
                            <v-btn
                                @click="
                                    on_switch_view_mode(
                                        'without-meta',
                                        6,
                                        'absolute',
                                        0
                                    )
                                "
                            >
                                <div>
                                    <span class="large-without-meta"></span>
                                </div>
                            </v-btn>
                        </v-btn-toggle>
                    </div>

                    <div class="switch-type-control">
                        <!-- 按条件排序 -->
                        <v-select
                            @change="on_chang_sort_type"
                            v-model="select"
                            :items="sortTypeItems"
                            item-text="text"
                            item-value="value"
                            label="最新上传"
                            return-object
                            single-line
                            item-color="#106951"
                            dense
                            :outlined="false"
                            :menu-props="{ contentClass: 'emerald-compact-dropdown', minWidth: 114, maxWidth: 118, offsetY: true, nudgeBottom: 4 }"
                        ></v-select>
                        <!-- 按类型筛选 -->
                        <v-select
                            :value="TypeSelect"
                            :items="filterTypeItems"
                            @input="on_change_select"
                            item-text="text"
                            item-value="value"
                            return-object
                            single-line
                            item-color="#106951"
                            dense
                            :outlined="false"
                            :menu-props="{ contentClass: 'emerald-compact-dropdown', minWidth: 114, maxWidth: 118, offsetY: true, nudgeBottom: 4 }"
                        ></v-select>
                        <!-- 按尺寸筛选 -->
                        <v-select
                            :value="SizeSelect"
                            :items="filterSizeItems"
                            @input="on_change_size"
                            item-text="text"
                            item-value="value"
                            return-object
                            single-line
                            item-color="#106951"
                            dense
                            :outlined="false"
                            :menu-props="{ contentClass: 'emerald-compact-dropdown', minWidth: 114, maxWidth: 118, offsetY: true, nudgeBottom: 4 }"
                        ></v-select>
                        <!-- 教会生活素材切换室内外 -->
                        <v-select
                            v-show="
                                this.$route.params.categories ===
                                '0AChSkKAoqzZMUk9PVA'
                            "
                            @change="on_chang_church_life"
                            :value="churchLifeModel"
                            :items="churchLifeItems"
                            item-text="text"
                            item-value="value"
                            label="全部"
                            return-object
                            single-line
                            item-color="#106951"
                            dense
                            :outlined="false"
                            :menu-props="{ contentClass: 'emerald-compact-dropdown', minWidth: 114, maxWidth: 118, offsetY: true, nudgeBottom: 4 }"
                        ></v-select>
                    </div>
                </div>

                <div class="post-img-box" :class="[WithoutMeta, { 'layout-preparing': !isLayoutReady }]" :style="containerMinHeight ? `min-height: ${containerMinHeight}px;` : ''" ref="postImgBox">
                    <!-- 尺寸桩：供 Masonry 百分比布局精确度量基准列宽，彻底杜绝单列错误 -->
                    <div class="grid-sizer" aria-hidden="true"></div>
                    <!-- 1. 卡片真实内容（有素材时渲染） -->
                    <template v-if="allCardList && allCardList.length > 0">
                        <VCards
                            @ccPreview="on_preview"
                            @card-click="handleCardClick"
                            v-for="(item, key) in allCardList"
                            :key="item.fileId ? 'card-' + item.fileId : 'card-idx-' + key"
                            :cardData="item"
                            :index="key"
                        />
                    </template>
                    <!-- 2. 情感化高颜值空状态：仅在加载完成且后端接口明确确认 total === 0 时才显示 -->
                    <template v-else-if="showEmptyState">
                        <div class="empty-state-box">
                            <div class="empty-illustration">
                                <div class="empty-glow"></div>
                                <v-icon class="empty-icon">mdi-image-search-outline</v-icon>
                            </div>
                            <h3 class="empty-title">未找到相关素材</h3>
                            <p class="empty-desc">
                                {{ keyword ? `没有找到与“${keyword}”相关的素材，可尝试更换关键词或清除部分筛选条件。` : '当前选中的分类或多维筛选组合下暂无素材，建议尝试其他分类或重置筛选。' }}
                            </p>
                            <div class="empty-actions">
                                <v-btn
                                    rounded
                                    depressed
                                    color="#0d9488"
                                    dark
                                    class="reset-btn"
                                    @click="on_reset_all_filters"
                                >
                                    <v-icon left small>mdi-refresh</v-icon>
                                    重置所有筛选
                                </v-btn>
                                <v-btn
                                    rounded
                                    outlined
                                    color="#0d9488"
                                    class="all-materials-btn"
                                    @click="on_go_all_materials"
                                    v-if="keyword || $route.params.categories"
                                >
                                    <v-icon left small>mdi-compass-outline</v-icon>
                                    浏览全部素材
                                </v-btn>
                            </div>
                        </div>
                    </template>
                    <!-- 3. 加载中或数据未到达过渡期：显示流光骨架屏，绝不提前显示空状态 -->
                    <template v-else>
                        <div class="skeleton-grid" style="width: 100%">
                            <div
                                v-for="n in 12"
                                :key="'skel-' + n"
                                class="skeleton-card"
                                :class="'ratio-' + (n % 4)"
                            >
                                <div class="skeleton-thumb"></div>
                                <div class="skeleton-meta">
                                    <div class="skeleton-title"></div>
                                    <div class="skeleton-sub"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- <v-loading v-else/> -->
                <!-- 滚动加载loading -->
                <loadMore
                    v-if="allCardListMeta.total"
                    :isShow="paginationShow"
                    :isError="loadMoreError"
                    @retry="on_retry_load_more"
                />
                <!-- 触底仪式感：已加载全部素材 -->
                <div class="gallery-end-divider" v-if="loadAll && allCardList.length !== 0">
                    <span class="divider-line line-left"></span>
                    <div class="end-badge">
                        <svg class="badge-svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14.5l-4-4 1.41-1.41L11 13.67l6.59-6.59L19 8.5l-8 8z"/>
                        </svg>
                        <span class="badge-title">已加载全部数据</span>
                        <span class="badge-count" v-if="allCardListMeta.total">共 {{ allCardListMeta.total }} 项</span>
                    </div>
                    <span class="divider-line line-right"></span>
                </div>
            </div>
        </div>
        <!-- <div class="mygallery-box" v-else>
      <v-loading />
    </div> -->
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { timeout } from "@/utils/util";
import { get_api_data } from "@/utils/ajax";
import { throttle } from "throttle-debounce";
import VCards from "./components/card/index";
import loadMore from "./components/load-more/index";
import lv1TagsList from "./components/lv1-tags-list/index";
import lv2CategoriesTags from "./components/lv2-categories-tags/index";
import Masonry from "masonry-layout";

export default {
    name: "home-main",
    components: {
        VCards,
        loadMore,
        lv1TagsList,
        lv2CategoriesTags,
    },
    data() {
        this.msnry = null;
        this.timer = this.timerLayout = null;
        this.searchLoading = false;
        return {
            localLoading: false,
            select: { text: "最新上传", value: "created_at" },
            sortTypeItems: [
                { text: "名称", value: "name" },
                { text: "最新上传", value: "created_at" },
                { text: "点赞最多", value: "likes" },
                { text: "下载最多", value: "downloads" },
                { text: "最不喜欢", value: "dislikes" },
            ],
            filterTypeItems: [
                { text: "不限类型", value: "all" },
                { text: "仅图片", value: "image" },
                { text: "仅视频", value: "video" },
            ],
            filterSizeItems: [
                { text: "不限尺寸", value: "all" },
                { text: "方版", value: "S" },
                { text: "横版", value: "H" },
                { text: "竖版", value: "V" },
            ],
            churchLifeItems: [
                { text: "全部", value: "0" },
                { text: "室内", value: "1" },
                { text: "室外", value: "2" },
                { text: "综合", value: "3" },
            ],
            search_img_info: [],
            mygallery:
                ".grid-sizer, .card-post-img{width: calc(100% / 8)!important;}.post-title{position: unset!important;padding: 0!important;}.post-title b{opacity: 1!important;}",
            paginationShow: false,
            // pagedNum: 1,
            isGetData: false,
            cardListBox: [],
            lv1_categories: [],
            lv2_categories: [],
            WithoutMeta: null,
            toggle_view_mode: 0,
            loadAll: false,
            isLayoutReady: true,
            lastSelectedIndex: -1,
            loadMoreError: false,
            isLoadingMore: false,
            savedScrollTop: 0,
            containerMinHeight: 0,
            // defaultIndex: 0
        };
    },
    computed: {
        ...mapState("global", [
            "navInfos",
            "TypeSelect",
            'SizeSelect',
            "churchLifeModel",
            // "filterTypeItems",
            "allCardList",
            "allCardListMeta",
            "keyword",
            "driveIdsID",
            "lv1_ID",
            "lv2_ID",
            "starTime",
            "endTime",
            "firstLoadingDone",
            "download_start",
            "download_end",
        ]),
        ...mapState("batchOperation", ["selectedCards"]),
        // 严谨空状态判定：仅当真实无数据、且非加载态、且后端接口确证 total === 0 时才展示
        showEmptyState() {
            // 1. 如果已有真实素材卡片，绝不展示空状态
            const hasList = this.allCardList && this.allCardList.length > 0;
            if (hasList) return false;

            // 2. 只要处于加载态（全局加载中、本地加载中或首屏未完成），100% 由流光骨架屏承接，严禁露出一丝空状态
            const isLoading = this.isListLoading || this.localLoading || !this.firstLoadingDone;
            if (isLoading) return false;

            // 3. 必须在接口明确返回、total 存在且严格为 0 时才允许展示
            return Boolean(
                this.allCardListMeta &&
                typeof this.allCardListMeta.total === 'number' &&
                this.allCardListMeta.total === 0
            );
        },
    },
    watch: {
        allCardList(newVal) {
            this.updateIsListLoading(false);
            if (newVal && newVal.length > 0) {
                this.layoutMasonry();
            }
        },
        navInfos: function (newValue) {
            this.update_lv_categories(newValue);
        },

        $route(to, from) {
            const isHome = to.name === "home" || to.path === "/" || !to.params.categories;
            const isDriveOnly = Boolean(to.params.categories && !to.params.materialList);
            const routeDrive = isHome ? [] : [to.params.categories];
            const routeLv1 = (isHome || isDriveOnly) ? [] : [to.params.materialList];

            // 检查目标分类是否已有 SWR 缓存
            const cached = categoryCache.get({
                driveIds: routeDrive,
                lv1_categories: routeLv1,
                scenes: this.churchLifeModel || 0
            });
            // 仅当未命中缓存时才设为加载态；命中缓存时保持 false，保障秒开流畅
            this.updateIsListLoading(!cached);

            this.update_lv_categories(this.navInfos, to.params.categories);
            this.updateTypeSelect("all");
            this.updateSizeSelect("all");
            this.updateChurchLifeModel(0);

            if (!to.query.s) {
                this.updateDriveIdsID(routeDrive);
                this.updateLv1_ID(routeLv1);
            }
            this.updateSequenceType(this.sequenceType);
            this.updateStarTime("");
            this.updateEndTime("");
            this.GLOBAL.scrollPage = 1;
            this.isGetData = false;
            this.isLayoutReady = false;
            this.loadAll = false;
            this.loadError = false;
            this.containerMinHeight = 0;
            this.isLoadingMore = false;
            this.loadMoreError = false;

            // 平滑温和回顶
            try {
                if (window.scrollY > 0) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            } catch (e) {
                window.scrollTo(0, 0);
            }

            to.params.categories === "0AChSkKAoqzZMUk9PVA"
                ? this.updateChurchLifeModel(0)
                : this.updateChurchLifeModel("");

            // 触发瀑布流平滑就位
            this.layoutMasonry();
        },

        mygallery() {
            $("#font-size-style").html(`${this.mygallery}`);
        },
    },
    created() {
        $("#font-size-style").html(`${this.mygallery}`);
        if (Object.keys(this.$route.params).length > 0) {
            this.update_lv_categories(this.navInfos, this.$route.params.categories);
            this.updateDriveIdsID([this.$route.params.categories]);
            this.updateLv1_ID([this.$route.params.materialList]);
            this.updateTypeSelect("all");
            this.updateSizeSelect("all");
            this.updateChurchLifeModel(0);
            this.updateStarTime("");
            this.updateEndTime("");
        } else {
            // 首页全库模式
            this.update_lv_categories(this.navInfos, "");
            this.updateDriveIdsID([]);
            this.updateLv1_ID([]);
            this.updateTypeSelect("all");
            this.updateSizeSelect("all");
            this.updateChurchLifeModel(0);
            this.updateStarTime("");
            this.updateEndTime("");
        }

        // 处理滚动加载（严格状态机互斥锁，杜绝并发触发与异常死循环）
        this.card_scroll = throttle(400, () => {
            if (this.loadAll || this.isLoadingMore) {
                return;
            }

            if (this.allCardListMeta && this.allCardListMeta.last_page <= 1) {
                this.paginationShow = false;
                this.loadAll = true;
                return;
            }

            let pageHeight = $(document).height();
            let scrollTop = $(window).scrollTop();
            let clientHeight = window.innerHeight;

            // 距离底部 450px 触发加载更多
            if (pageHeight - (scrollTop + clientHeight) < 450) {
                if (this.GLOBAL.scrollPage < this.allCardListMeta.last_page) {
                    this.savedScrollTop = scrollTop;
                    this.isLoadingMore = true;
                    this.paginationShow = true;
                    this.loadMoreError = false;
                    this.GLOBAL.scrollPage = this.GLOBAL.scrollPage + 1;
                    this.get_card_list(this.GLOBAL.scrollPage);
                } else {
                    this.loadAll = true;
                    this.paginationShow = false;
                }
            }
        });

        this.$P.$on("updateSearchFn", (keyword) => {
            this.updateKeyword(keyword);
            this.get_image_card_list();
        });

        // this.add_google_analytics();
    },
    mounted() {
        $("#font-size-style").html(`${this.mygallery}`);
        window.addEventListener("scroll", this.card_scroll);
        this.layoutMasonry();
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.card_scroll, false);
        if (this.msnry && typeof this.msnry.destroy === "function") {
            try {
                this.msnry.destroy();
            } catch (e) {}
            this.msnry = null;
        }
    },
    updated() {
        this.layoutMasonry();
    },
    methods: {
        ...mapMutations("global", [
            "updateIsListLoading",
            "updateAllCardList",
            "updateAllCardListMeta",
            "updateDriveIdsID",
            "updateLv1_ID",
            "updateLv2_ID",
            "updateTypeSelect",
            "updateSizeSelect",
            "updateChurchLifeModel",
            "updateSequenceType",
            "updateStarTime",
            "updateEndTime",
            "updateFirstLoadingDone",
            "updateKeyword",
        ]),
        ...mapMutations("batchOperation", ["addSelectedCards"]),

        // 统一瀑布流调度（物理高度锁 + 区分全量重排与增量追加，杜绝容器高度坍塌导致视口跳顶）
        layoutMasonry(isAppend = false) {
            if (!this.$refs.postImgBox) return;
            this.$nextTick(() => {
                if (!this.$refs.postImgBox) return;

                // 物理高度锁：先锁定当前实际高度，防止重排瞬间发生页面高度缩水
                const currentH = this.$refs.postImgBox.offsetHeight;
                if (currentH > this.containerMinHeight) {
                    this.containerMinHeight = currentH;
                }

                // 增量追加场景：若已有实例则直接复用，绝不销毁已有卡片与容器高度
                if (isAppend && this.msnry && typeof this.msnry.reloadItems === "function") {
                    this.msnry.reloadItems();
                    this.msnry.layout();

                    requestAnimationFrame(() => {
                        if (this.$refs.postImgBox) {
                            const newH = this.$refs.postImgBox.offsetHeight;
                            if (newH > this.containerMinHeight) {
                                this.containerMinHeight = newH;
                            }
                        }
                    });
                    return;
                }

                // 全量重排场景（初次挂载、切换分类、执行搜索）：安全重建实例
                try {
                    if (this.msnry && typeof this.msnry.destroy === "function") {
                        this.msnry.destroy();
                    }
                } catch (e) {}

                this.msnry = new Masonry(this.$refs.postImgBox, {
                    itemSelector: ".grid-item",
                    columnWidth: ".grid-sizer",
                    percentPosition: true,
                    transitionDuration: 0,
                });

                const triggerLayout = () => {
                    if (this.msnry && typeof this.msnry.layout === "function") {
                        this.msnry.layout();
                    }
                    if (this.$refs.postImgBox) {
                        const newH = this.$refs.postImgBox.offsetHeight;
                        if (newH > this.containerMinHeight) {
                            this.containerMinHeight = newH;
                        }
                    }
                };

                requestAnimationFrame(() => {
                    triggerLayout();
                    this.isLayoutReady = true;
                });
                setTimeout(triggerLayout, 60);
                setTimeout(triggerLayout, 180);
                setTimeout(triggerLayout, 350);
            });
        },

        update_lv_categories(navInfos, targetCategory) {
            const currentCat = targetCategory !== undefined 
                ? targetCategory 
                : (this.$route && this.$route.params ? this.$route.params.categories : "");

            if (!currentCat || !Array.isArray(navInfos)) {
                this.lv1_categories = [];
                this.lv2_categories = [];
                return;
            }

            let matched = false;
            navInfos.forEach((k) => {
                if (k.driveId == currentCat) {
                    this.lv1_categories = k.lv1_categories || [];
                    this.lv2_categories = k.lv2_categories || [];
                    matched = true;
                }
            });

            if (!matched) {
                this.lv1_categories = [];
                this.lv2_categories = [];
            }
        },
        // 按条件排序  OptionsType, OptionsTypeText
        on_chang_sort_type() {
            // 获取点击元素的属性  sequenceType
            this.sequenceType = this.select.value;
            this.updateSequenceType(this.sequenceType);
            this.GLOBAL.scrollPage = 1;
            this.get_image_card_list();
        },

        // 按类型筛选
        on_change_select(type) {
            // this.updateAllCardList("");
            this.updateTypeSelect(type.value);
            this.GLOBAL.scrollPage = 1;
            this.get_image_card_list();
        },
        // 按尺寸筛选
        on_change_size(size) {
            // this.updateAllCardList("");
            this.updateSizeSelect(size.value);
            this.GLOBAL.scrollPage = 1;
            this.get_image_card_list();
        },

        // 切换教会生活素材
        on_chang_church_life(scenes) {
            this.updateChurchLifeModel(scenes.value);
            this.GLOBAL.scrollPage = 1;
            this.get_image_card_list();
        },

        async on_search_filter(index, driveId) {
            this.searchLoading = true;
            if (index < 0) {
                this.updateDriveIdsID([]);
            } else {
                this.updateDriveIdsID([driveId]);
            }

            this.updateLv1_ID([]);
            this.GLOBAL.scrollPage = 1;
            this.get_image_card_list();
            await timeout(1000);
            if (allCardListMeta.total == 0) {
                this.searchLoading = false;
            }
        },

        // 获取图片列表数据
        async get_image_card_list() {
            this.containerMinHeight = 0;
            this.loadMoreError = false;
            this.isLoadingMore = false;
            this.updateIsListLoading(true);
            this.updateAllCardList("");
            this.loadAll = false;
            try {
                this.search_img_info = await get_api_data(
                    "GET",
                    "search",
                    this.get_ajax_data(this.GLOBAL.scrollPage)
                );
                this.updateAllCardList(this.search_img_info.data.data);
                this.updateAllCardListMeta(this.search_img_info.data.meta);
            } catch (err) {
                console.error("加载素材列表异常:", err);
            } finally {
                this.updateIsListLoading(false);
            }
            this.isGetData = false;

            if (this.allCardListMeta && this.allCardListMeta.last_page == 1) {
                this.loadAll = true;
            }
        },
        // 滚动加载请求回的数据，安全追加并增量就位
        async get_card_list(page) {
            try {
                this.cardListBox = await get_api_data(
                    "GET",
                    "search",
                    this.get_ajax_data(page)
                );

                if (
                    this.cardListBox &&
                    this.cardListBox.data &&
                    Array.isArray(this.cardListBox.data.data) &&
                    this.cardListBox.data.data.length > 0
                ) {
                    const newItems = this.cardListBox.data.data;
                    newItems.forEach((ke) => {
                        this.allCardList.push(ke);
                    });

                    // 执行增量排版，保留老元素绝对定位
                    this.layoutMasonry(true);

                    // 视口保位纠偏：检测是否发生浏览器异常跳顶
                    this.$nextTick(() => {
                        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
                        if (this.savedScrollTop > 0 && currentScroll < this.savedScrollTop - 200) {
                            window.scrollTo({ top: this.savedScrollTop, behavior: "instant" });
                        }
                    });

                    if (page >= this.allCardListMeta.last_page) {
                        this.loadAll = true;
                    }
                } else {
                    this.loadAll = true;
                }
                this.loadMoreError = false;
            } catch (err) {
                console.warn("滚动加载更多素材异常或稍有延迟:", err);
                this.loadMoreError = true;
                if (this.GLOBAL.scrollPage > 1) {
                    this.GLOBAL.scrollPage = this.GLOBAL.scrollPage - 1;
                }
                const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
                if (this.savedScrollTop > 0 && currentScroll < this.savedScrollTop - 200) {
                    window.scrollTo({ top: this.savedScrollTop, behavior: "instant" });
                }
            } finally {
                this.paginationShow = false;
                this.isLoadingMore = false;
            }
        },

        // 原地重新触发滚动加载
        on_retry_load_more() {
            if (this.isLoadingMore) return;
            this.savedScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.isLoadingMore = true;
            this.paginationShow = true;
            this.loadMoreError = false;
            this.GLOBAL.scrollPage = this.GLOBAL.scrollPage + 1;
            this.get_card_list(this.GLOBAL.scrollPage);
        },

        get_ajax_data(page) {
            return {
                driveIds: this.driveIdsID,
                lv1_categories: this.lv1_ID,
                lv2_categories: this.GLOBAL.activeLv2Id ? (Array.isArray(this.GLOBAL.activeLv2Id) ? this.GLOBAL.activeLv2Id : [this.GLOBAL.activeLv2Id]) : [],
                type: this.TypeSelect, // all  image  video
                size: this.SizeSelect, // all  S H V
                start: this.starTime, //2021-04-15
                end: this.endTime, //2021-04-15
                keyword: this.keyword,
                scenes: this.churchLifeModel,
                // inc_tag: "include",
                orderby: this.sequenceType, // createdTime  name downloads  likes
                order: "desc",
                per_page: 80,
                page: page,
                download_start: this.download_start,
                download_end: this.download_end,
            };
        },

        //  预览大图
        on_preview(index) {
            this.$preview(index, this);
        },

        handleCardClick(index, event) {
            if (event.shiftKey && this.lastSelectedIndex !== -1) {
                event.preventDefault();
                event.stopPropagation();
                this.selectRange(this.lastSelectedIndex, index);
            } else if (event.ctrlKey || event.metaKey) {
                this.lastSelectedIndex = index;
            }
        },

        selectRange(startIndex, endIndex) {
            const start = Math.min(startIndex, endIndex);
            const end = Math.max(startIndex, endIndex);

            for (let i = start; i <= end; i++) {
                const cardData = this.allCardList[i];
                if (cardData.is_qualified === -1) continue;

                const data = {
                    download_url: cardData.download_url,
                    fileId: cardData.fileId,
                    index: i
                };

                const alreadySelected = this.selectedCards.some(
                    item => item.fileId === cardData.fileId
                );

                if (!alreadySelected) {
                    this.addSelectedCards(data);
                    this.updateCardVisualState(i, true);
                }
            }
            this.lastSelectedIndex = endIndex;
        },

        // 重置所有筛选与搜索关键词，恢复初始状态
        on_reset_all_filters() {
            this.select = { text: "最新上传", value: "created_at" };
            this.sequenceType = "created_at";
            this.updateSequenceType("created_at");
            this.updateTypeSelect("all");
            this.updateSizeSelect("all");
            this.updateChurchLifeModel(0);
            this.updateStarTime("");
            this.updateEndTime("");
            this.updateKeyword("");
            this.GLOBAL.scrollPage = 1;
            this.GLOBAL.activeLv2Id = null;
            this.$P.$emit("resetSearchInput");
            this.get_image_card_list();
        },

        // 返回并浏览全部素材
        on_go_all_materials() {
            this.on_reset_all_filters();
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' }).catch(() => {});
            }
        },

        updateCardVisualState(index, isSelected) {
            const cardElement = $('.card-post-img').eq(index);
            if (isSelected) {
                cardElement.addClass('card-selected');
                // 触发 mouseenter 强制 Vue 渲染 checkbox
                const cardBox = cardElement.find('.card-post-img-box').get(0);
                if (cardBox) {
                    const mouseenterEvent = new MouseEvent('mouseenter', {
                        bubbles: true,
                        cancelable: true
                    });
                    cardBox.dispatchEvent(mouseenterEvent);
                }
                // 等待 Vue 渲染后设置 checkbox
                setTimeout(() => {
                    const checkbox = cardElement.find('.form-check-input').get(0);
                    if (checkbox) checkbox.checked = true;
                }, 10);
            } else {
                cardElement.removeClass('card-selected');
                const checkbox = cardElement.find('.form-check-input').get(0);
                if (checkbox) checkbox.checked = false;
            }
        },

        // 切换四种视图模式
        async on_switch_view_mode(WithoutMeta, width, position, opacity) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.WithoutMeta = WithoutMeta;
                this.mygallery = `.grid-sizer, .card-post-img{width: calc(100% / ${width}) !important;}.post-title{position: ${position}!important;padding: 0!important;}.post-title b{opacity: ${opacity}!important;}`;
                clearTimeout(this.timerLayout);
                this.timerLayout = setTimeout(() => {
                    this.msnry.layout();
                }, 300);
            }, 500);
            await timeout(1000);
            this.msnry.layout();
        },

        // 添加Google分析代码
        add_google_analytics() {
            var script = document.createElement("script");
            script.onload = function () {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }
                gtag("js", new Date());
                gtag("config", "G-9ZX9ELF3G2");
            };
            script.src =
                "https://www.googletagmanager.com/gtag/js?id=G-9ZX9ELF3G2";
            document.body.appendChild(script); //or something of the likes
        },
    },
};
</script>
